import { BUSINESS_INFO } from './constants';

export const generateWhatsAppMessage = (formData) => {
  const message = `Hello ARA Mobile Valeting,

I would like to book a service:

📝 Name: ${formData.name}
📞 Phone: ${formData.phone}
📧 Email: ${formData.email || 'Not provided'}
📍 Location: ${formData.postcode}
🚗 Service: ${formData.service}
📅 Preferred Date: ${formData.date}
🕐 Preferred Time: ${formData.time}
${formData.notes ? `\n💬 Additional Notes:\n${formData.notes}` : ''}

Looking forward to your service!`;

  return encodeURIComponent(message);
};

export const generateEmailLink = (formData) => {
  const subject = `Booking Request - ${formData.service}`;
  const body = `Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email || 'Not provided'}
Location: ${formData.postcode}
Service: ${formData.service}
Preferred Date: ${formData.date}
Preferred Time: ${formData.time}
${formData.notes ? `\nAdditional Notes:\n${formData.notes}` : ''}`;

  return `mailto:${BUSINESS_INFO.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const getWhatsAppLink = (phone, message = '') => {
  const cleanPhone = phone.replace(/\D/g, '');
  const whatsappMessage = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${cleanPhone}${whatsappMessage}`;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};